import { validTypeMap } from '@op/constants/common';

export function getValidation(validation: string) {
  return validTypeMap[validation] || validTypeMap[0];
}
